import React, { useCallback } from 'react';
import { Switch, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from  "../stateManagement/actions/types";

const ComparisonSwitch = () => {
    const dispatch = useDispatch();
    const {comparison} = useSelector((state) => state.reportReducer);

    // Memoize the toggle handler
    const handleToggleComparison = useCallback(() => {
        dispatch({ type: ActionTypes.SWITCH_COMPARISON_MODE });
    }, [dispatch]);

    return (
        <Tooltip title={
            <div>
                <p><strong>Last7days</strong> - compared with the previous 7 days</p>
                <p><strong>ThisMonth</strong> - compared with the same interval of the previous month</p>
                <p><strong>LastMonth</strong> - compared with the previous full month</p>
                <p><strong>Custom</strong> - compared with the previous days</p>
            </div>
        } color="#001529">
            <Switch
                style={{
                    margin: "0.25rem auto", 
                    width: "5rem"
                }}
                checkedChildren="Compare"
                unCheckedChildren="Compare"
                onChange={handleToggleComparison}
                checked={comparison}
            />
        </Tooltip>
    )
};

export default ComparisonSwitch;